import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import searchIcon from 'images/search_icon.svg';

import { PrimaryButton } from '@components/Button/variants';
import { search_page_path } from '@routes';

export default function SearchBar({
  isSearchLandingPage,
  scope,
}: {
  isSearchLandingPage: boolean;
  scope: string;
}) {
  const [query, setQuery] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>();

  const handleChange = (e) => setQuery(e.target.value);

  return (
    <div className="px-16">
      <div
        className={clsx({
          'mx-auto max-w-[600px]': isSearchLandingPage,
        })}
      >
        <form id="form_id" action={search_page_path()} method="get" data-id="search-form">
          <div className="flex flex-col gap-16">
            <div className="flex items-center gap-12">
              <img src={searchIcon} width="24" height="24" alt="" />
              <div>
                <h1 className="m-0 p-0 text-headline-xs font-bold leading-none">
                  Search The Information
                </h1>
                <p className="m-0 font-suisse-intl-mono text-caption-sm">Powered by AI</p>
              </div>
            </div>
            <textarea
              name="query"
              className="mb-8 min-h-[75px] w-full min-w-full max-w-full border-grayscale-gray px-16 py-10 text-body-sm text-grayscale-gray"
              value={query}
              onChange={handleChange}
              ref={textAreaRef}
            />
            <PrimaryButton as="button" className="self-end" type="submit">
              Search
            </PrimaryButton>
          </div>
          <input type="hidden" name="scope" value={scope} />
        </form>
      </div>
    </div>
  );
}
